var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.lastInvoice)?_c('saved-invoice',{attrs:{"activeTab":_vm.activeTab,"invoice":_vm.lastInvoice}}):_c('empty-invoice',{on:{"on-create-invoice":_vm.onCreate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }